import { Sound } from "excalibur";

export function range(start: number, end: number) {
    return Array.from({ length: end - start }, (_, i) => i + start);
}

export function random_int(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function playStart(sound: Sound) {
    sound.stop();
    sound.play();
}